export const appConfig = {
    COGNITO_URL: process.env.REACT_APP_COGNITO_URL,
    RESTPOINT_URL: process.env.REACT_APP_RESTPOINT_URL,
    CLIENT_ID_MOBILE: process.env.REACT_APP_CLIENT_ID_MOBILE,
    CLIENT_ID_WEB: process.env.REACT_APP_CLIENT_ID_WEB,
    REDIRECT_URL_MOBILE: process.env.REACT_APP_REDIRECT_URL_MOBILE,
    REDIRECT_URL_WEB: process.env.REACT_APP_REDIRECT_URL_WEB,
    LOGOUT_URL_MOBILE: process.env.REACT_APP_LOGOUT_URL_MOBILE,
    LOGOUT_URL_WEB: process.env.REACT_APP_LOGOUT_URL_WEB,
    EMAIL_HIDDEN_INSTRUCTION_URL: "https://pdfs.dadeschools.net/Apple/Apple%20ID%20instructions.pdf"
};